import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import Logo from '../assets/logo1.jpeg';
import 'animate.css';

const Header = () => {
const [showNav, setShowNav] = useState(false);
const navigate = useNavigate();

  return (
    <>
<header className='py-2 sticky-top bg-white'>
    <div className='container d-flex justify-content-between'>

<img src={Logo} alt='Logo' className='header-img' />
<div className='align-content-center d-lg-block d-none'>
    <NavLink className='nav-text' activeClassName='active' to='/'>Home</NavLink>
    <NavLink className='nav-text' activeClassName='active' to='/about'>About</NavLink>
    {/* <NavLink className='nav-text' activeClassName='active' to='/gallery'>Gallery</NavLink> */}
    <NavLink className='nav-text' activeClassName='active' to='/tour-packages'>Tour Packages</NavLink>
    <NavLink className='nav-text' activeClassName='active' to='/contact'>Contact</NavLink>
</div>

<span className='me-3 d-lg-none d-block align-content-center' onClick={() => setShowNav(true)}><i class="fa-solid fa-bars fs-5"></i></span>
<div className='align-content-center'>
<button className='nav-btn' onClick={() => navigate('/contact')}>Book Now<i class="fa-solid fa-arrow-right ps-2"></i></button></div>

    </div>
</header>

{showNav && (
  <>
  <div className='sidebar-area animate__animated animate__fadeInDown'>
<span onClick={() => setShowNav(false)} className='float-end'><i class="fa-solid fa-circle-xmark fs-5"></i></span><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/'>Home</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/about'>About</NavLink><br /><br />
    {/* <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/gallery'>Gallery</NavLink><br /><br /> */}
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/tour-packages'>Tour Packages</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName='active' to='/contact'>Contact</NavLink>

  </div>
  </>
)}
    </>
  )
}

export default Header
